module.exports = __webpack_public_path__ + "static/media/Mesa-de-presentación.386967d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/productos/Mesa-de-presentación.jpg
// module id = 140
// module chunks = 0